export const inviteFriend = {
  inviteFriendEmail: "E-pos",
  inviteFriendEmailError: "Ongeldige e-pos",
  inviteFriendDate: "Datum",
  inviteFriendButton: "Nooi",
  inviteFriendRegistered: "Geregistreerde vriende",
  inviteFriendLoadingList: "Laai gastelys...",
  inviteFriendNoReferrals: "Geen geregistreerde vriende nie.",
  inviteFriendToSeeThemHere: "Nooi vriende om hulle hier te sien",
};
